module.exports = __webpack_public_path__ + "static/media/placemark.f87ff241.svg";